import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

// Services
import { NavigationParam, RouteParam, ServiceBase } from '../service-base';

// Modèles
import { QuotationItem } from 'src/app/@shared/models/sales/quotation/quotation-item.model';

const CLASS_NAME = 'QuotationItem';
const ENDPOINT = `/quotation-items/`;
const NAVIGATIONS: NavigationParam[] = [
    { key: 'schedule', path: 'schedule/', childClass: 'PaymentSchedule', resultCardinality: 'one' },
]
const ROUTES: RouteParam[] = [
    { key: 'cap', path: '{id}/cap/' },
]

@Injectable({
    providedIn: 'root'
})
export class QuotationItemService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addNavigations(NAVIGATIONS);
        this.addRoutes(ROUTES);
    }

    /**
     * Pose le plafond d'avancement de la ligne (en %). `null` clôture la ligne :
     * le serveur cale alors le plafond au plancher facturé / acompte (#847).
     * La réponse ne porte que la ligne : recharger le devis pour l'entête.
     */
    public updateCap$(item: QuotationItem, progressionCap: number | null): Observable<QuotationItem> {
        const url = this.routes['cap'].replace('{id}', item.id.toString());
        const body = progressionCap === null ? {} : { progressionCap: progressionCap };
        return this._putAction$<QuotationItem>(url, body).pipe(
            tap(instance => this._updated$.next(instance))
        );
    }
}
